<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-lg-auto">
        <RestaurantForm />
      </div>
    </div>
  </div>
</template>

<script>
import RestaurantForm from './components/RestaurantForm.vue'

export default {
  name: 'Home',
  components: { RestaurantForm },
}
</script>
